export default angular.module('BaseClass.validatable.validation',[])
    .factory('BCValidation', function() {
        function Validation(field, validationFn) {
            this.field = field;
            this.message = validationFn.message;
            this.validator = validationFn.validator;
            this.validate = function(instance) {
                return validationFn(instance[field], instance, field);
            };
        }

        return Validation;
    }).name;
